import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const listInventoryLocations = () =>
  axios.get(
    `${getV2RootUrl()}/inventory-location/pickup`,
    publicAxiosHeaderV2()
  );
